module.exports = __webpack_public_path__ + "static/media/BIM 360 Build.bf623a92.png";